import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface SelectedRowsProps {
  dataVencimento: string;
  fixo: boolean;
  frequencia: number;
  idSerie: string;
  juros: boolean;
  qtdParcelas: number;
  tipoSerie: number;
  valorParcela: number;
  valorTotal: number | null | undefined;
}

interface Props {
  onClose: () => void;
  tableData: any;
  refetch: () => void;
  selectedRow?: SelectedRowsProps;
  idLeadCorretor: string;
}

const EditarItemModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        tableData={props?.tableData}
        refetch={props?.refetch}
        selectedRow={props?.selectedRow}
        idLeadCorretor={props?.idLeadCorretor}
      />
    </Styles.Container>
  );
};

export default EditarItemModal;
